/**
 * Response header constants for EASYAI API
 * These match the backend header names defined in function_executor.py
 */

export const REQUEST_HEADERS = {
  USAGE: 'EASYAI-REQUEST-USAGE',
  INPUT_TOKENS: 'EASYAI-REQUEST-INPUT-TOKENS',
  OUTPUT_TOKENS: 'EASYAI-REQUEST-OUTPUT-TOKENS',
  CREDITS_USED: 'EASYAI-REQUEST-CREDITS-USED',
  ALL_TOKEN_INFO: 'EASY-ALL-TOKEN-INFO',
  RUN_ID: 'EASYAI-RUN-ID',
} as const;
